"use strict";

import MultiItemInteractionView from "/js/interaction-views/multi-item-interaction-view.js"
import MultipleChoiceItemView from "/js/interaction-views/multiple-choice-item-view.js"
/**
 * 
 */
export default class MultipleChoiceInteractionView extends MultiItemInteractionView {
  
  initContent() {
    const numItems = this.data.questions.length;
    this.data.questions.forEach(function(question, index) {
      const item = new MultipleChoiceItemView(question, index, numItems);
      this.$el.append(item.$el);
      this.items.push(item);
    }, this);
  }
}
